/**
 * Horizontal "or" separator between Google SSO and email auth.
 */
import React from "react";
import PropTypes from "prop-types";
import { TvDiv, TvSpan } from "@trustvid/design-system";

const AuthFormDivider = ({ children }) => (
  <TvDiv className="tv-login-page__divider" data-testid="auth-form-divider" role="separator">
    <TvSpan>{children}</TvSpan>
  </TvDiv>
);

AuthFormDivider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthFormDivider;
